export default class Hashtag {
    constructor(name) {
        this.name = name;
      }
    
      static fromJson(json) {
        return new Hashtag(json.name);
      }
}